const worker = function () {
  return {
    active: '',
    active_first: '',

    openTabOnHover(tab) {
      if (window.innerWidth >= 1025) {
        this.active = tab
      }

      // this.getActive()
    },
    closeTabOnHover() {
      if (window.innerWidth >= 1025) {
        this.active = this.active_first
      }

      // this.getActive()
    },
    toggleTabOnClick(tab) {
      if (window.innerWidth < 1025) {
        if (this.active === tab) {
          this.active = '';
        } else {
          this.active = tab;
        }
      }
    },

    getActive() {
      const container = document.querySelector('.quiz-features__container');
      const container_width = container.clientWidth;
      const size = container.dataset.size;
      const tabs = document.querySelectorAll('.quiz-features__feature');
      const width = container_width - (size * 90) - 4;
      tabs.forEach((tab) => {
        const tab_body = tab.querySelector('.quiz-features__feature--body');
        const height = tab_body.querySelector('.quiz-features__feature--body-inner').clientHeight
        if (tab.classList.contains('active')) {
          if( window.innerWidth >= 1025) {
            tab_body.style.width = width + 'px';
          } else {
            tab_body.style.height = height + 'px';
          }
        } else {
          if( window.innerWidth >= 1025) {
            tab_body.style.width = 0 + 'px';
          } else {
            tab_body.style.height = 0 + 'px';
          }
        }
      })

    },

    setHeight() {
      if( window.innerWidth >= 1025) {
        const container = document.querySelector('.quiz-features__container');
        const height = container.clientHeight;
        container.style.height = height + 'px';
      }
    },

    startQuiz() {
      const start_quiz_btns = document.querySelectorAll('.js-start-quiz');
      start_quiz_btns.forEach(btn => {
        btn.addEventListener('click', ()=> {
          this.$dispatch('start-quiz', { start: true});
        })
      })
    },

    init () {
      this.setHeight();
      this.startQuiz();
      this.$watch('active', ()=> {
        this.getActive();
      })
    }
  }
}

document.addEventListener('alpine:init', () => {
Alpine.data('quizFeatures', worker);
});